// FormProjectSetting Component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Checkbox from '../../../common/form/checkbox/checkbox.jsx'

class FormProjectSetting extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      useProjectNo: props.data.useProjectNo || false,
      isGenerated: props.data.isGenerated !== false,
      isPmVisible: props.data.isPmVisible || false,
      showProMemoria: props.data.showProMemoria || false
    }
  }

  static get propTypes () {
    return {
      data: PropTypes.object,
      onSubmit: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      data: null,
      onSubmit: null
    }
  }

  /* Render Function */
  render () {
    const { useProjectNo, isGenerated, isPmVisible, showProMemoria } = this.state

    return (
      <div className='form-projectsetting'>
        <form
          method='post'
          noValidate
          action='#'
          onSubmit={this._onSubmit.bind(this)}
        >
          <div className='form-layout'>
            <div className='layoutcol'>
              <div className='formsection'>
                <div className='formrow'>
                  <div className='formcol'>
                    <Checkbox
                      label='setting.project.labelPmVisibility'
                      className='form-checkbox_alt'
                      checked={isPmVisible}
                      icon='common'
                      onChange={this._onChangeCheckbox.bind(
                        this,
                        'isPmVisible'
                      )}
                    />
                  </div>
                </div>
                <div className='formrow'>
                  <div className='formcol'>
                    <Checkbox
                      label='setting.project.labelProjectNo'
                      className='form-checkbox_alt'
                      checked={useProjectNo}
                      icon='common'
                      onChange={this._onChangeCheckbox.bind(
                        this,
                        'useProjectNo'
                      )}
                    />
                  </div>
                </div>
                {useProjectNo && (
                  <div className='formrowoption'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Checkbox
                          label='setting.project.labelGenerated'
                          className='form-checkbox_alt'
                          checked={isGenerated}
                          icon='radio'
                          onChange={this._onChangeCheckbox.bind(
                            this,
                            'isGenerated',
                            true
                          )}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Checkbox
                          label='setting.project.labelCreated'
                          className='form-checkbox_alt'
                          checked={!isGenerated}
                          icon='radio'
                          onChange={this._onChangeCheckbox.bind(
                            this,
                            'isGenerated',
                            false
                          )}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className='formrow'>
                <div className='formcol'>
                  <Checkbox
                    label='setting.project.showProMemoria'
                    className='form-checkbox_alt'
                    checked={showProMemoria}
                    icon='common'
                    onChange={this._onChangeCheckbox.bind(
                      this,
                      'showProMemoria'
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <IconButton
            icon='common-success-tick'
            title='setting.integration.tipSave'
            type='primary'
            size='big'
            canHover={false}
            className='wizard-submit'
            onClick={this._onSubmit.bind(this)}
          />
        </form>
      </div>
    )
  }

  /* Event handlers */

  _onSubmit (ev) {
    ev.preventDefault()

    const { useProjectNo, isGenerated, isPmVisible, showProMemoria } = this.state
    const updateData = {
      useProjectNo: useProjectNo,
      isGenerated: isGenerated,
      isPmVisible: isPmVisible,
      showProMemoria: showProMemoria
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(updateData)
    }
  }

  _onChangeCheckbox (name, bChecked) {
    this.setState({ [name]: bChecked, dataDate: new Date() })
  }
}

export default FormProjectSetting
